$traceurRuntime.ModuleStore.getAnonymousModule(function() {
  "use strict";
  angular.module('app.module').directive('slide', function() {
    return {
      scope: true,
      link: function(scope, element, attributes) {
        scope.contentUrl = 'module/slides/' + attributes.type + '.html';
      },
      template: '<div class="slide_cnt" ng-include="contentUrl"></div>'
    };
  }).directive('feedbackCnt', function(VoiceOver) {
    return {
      scope: {
        feedback: '=',
        content: '=content'
      },
      templateUrl: 'components/feedback.html',
      link: (function($scope, elem, attr) {
        $scope.close = (function() {
          VoiceOver.stop();
          $scope.$parent.slideObj.feedback = 'hide';
        });
      })
    };
  }).directive('shadow', function() {
    return {templateUrl: 'components/shadow.html'};
  }).directive('timerpopupCnt', function() {
    return {
      scope: {content: '=content'},
      templateUrl: 'components/timer-popup.html',
      link: (function($scope, elem, attr) {
        $scope.close = (function() {
          $scope.$parent.slideObj.timerpopup = 'hide';
        });
        $scope.next = (function() {
          $scope.$parent.next();
        });
      })
    };
  }).directive('checklist', function($rootScope, AudioManager) {
    return {
      scope: {
        answers: '=',
        results: '=',
        columns: '='
      },
      templateUrl: 'components/checklist.html',
      link: (function($scope, elem, attr) {
        $scope.count = {};
        $scope.countUp = (function($event, index) {
          AudioManager.play('click');
          if ($scope.count[index] == null) {
            $scope.count[index] = 0;
          }
          $scope.count[index]++;
          if ($rootScope.selectedAnswer.indexOf(index) < 0) {
            $rootScope.selectedAnswer.push(index);
          }
        });
        $scope.countDown = (function($event, index) {
          AudioManager.play('click_alt');
          if ($scope.count[index] == null) {
            $scope.count[index] = 0;
          }
          $scope.count[index]--;
          if ($scope.count[index] == 0) {
            var true_index = parseInt($rootScope.selectedAnswer.indexOf(index));
            $rootScope.selectedAnswer.splice(true_index, 1);
          }
        });
      })
    };
  }).directive('actionsCnt', function($rootScope, $timeout, $stateParams, Analytics, AnswerAPI, AudioManager, VoiceOver) {
    return {
      templateUrl: 'components/interaction-actions.html',
      link: (function($scope, elem, attr) {
        console.log($scope.slide.timer);
        $scope.showFeedback = false;
        $scope.countdown = (typeof $scope.slide.timer !== 'undefined' ? $scope.slide.timer : 10);
        $scope.hasVoted = false;
        $scope.feedback = false;
        $scope.subType = (typeof $scope.slide.subtype !== 'undefined' ? $scope.slide.subtype : false);
        $scope.disabledDrag = ($rootScope.disabledDrag ? true : false);
        if (typeof $scope.slide.feedback !== 'undefined') {
          if ($scope.slide.type != 'abcd' && $scope.slide.type != 'dilemma') {
            $scope.hasMultipleAnswers = true;
          }
          $scope.showFeedback = (typeof $scope.slide.feedback.correct === 'boolean' ? 'simple' : 'correct');
          $scope.isScoreTest = (typeof $scope.slide.feedback.scores !== 'undefined' ? $scope.slide.feedback.scores : false);
        } else {
          $scope.showFeedback = false;
          if ($scope.slide.type != 'abcd' && $scope.slide.type != 'dilemma') {
            $scope.hasMultipleAnswers = true;
          }
        }
        $scope.checkDragDropAnswer = (function() {
          VoiceOver.stop();
          if ($scope.slide.feedback.voice_over) {
            VoiceOver.play($scope.slide.feedback.voice_over, function() {
              $rootScope.$broadcast('state', {state: 'done'});
            });
          }
          $scope.feedback = AnswerAPI.checkDragDrop($scope.slide.subtype, $scope.slide.words, $scope.selectedAnswer);
          $scope.slideObj.stage = 'results';
          $scope.slideObj.feedback = 'show';
          if ($scope.feedback) {
            if ($scope.feedback.type != 'wrong') {
              $rootScope.selectedAnswer = $scope.feedback.correct;
              $rootScope.$broadcast('checkedAnswer', $rootScope.selectedAnswer);
            }
          }
        });
        $scope.checkAnswer = (function() {
          VoiceOver.stop();
          if ($scope.slide.feedback.voice_over) {
            VoiceOver.play($scope.slide.feedback.voice_over, function() {
              $rootScope.$broadcast('state', {state: 'done'});
            });
          }
          if ($scope.hasVoted) {
            $scope.feedback = AnswerAPI.checkVote($scope.hasMultipleAnswers, $scope.slide.feedback.correct, $scope.hasVoted);
          } else {
            $scope.feedback = AnswerAPI.check($scope.slide.feedback.correct, $scope.selectedAnswer);
          }
          $scope.slideObj.stage = 'results';
          $scope.slideObj.feedback = 'show';
        });
        $scope.getFeedback = (function() {
          VoiceOver.stop();
          if ($scope.slide.feedback.voice_over) {
            VoiceOver.play($scope.slide.feedback.voice_over, function() {
              $rootScope.$broadcast('state', {state: 'done'});
            });
          }
          $scope.feedback = false;
          $scope.slideObj.feedback = 'show';
        });
        $scope.startVote = (function() {
          console.log('countdown to vote...');
          $scope.showVoteAlert = true;
          setTimeout(function() {
            $scope.showVoteAlert = false;
            console.log('start voting...');
            AnswerAPI.vote($scope.hasMultipleAnswers, $scope.subType, $scope.chapterPagination, $scope.slide.answers, $scope.countdown, $scope);
          }, 2500);
        });
        $scope.$on('voteDone', (function(event, data) {
          $scope.hasVoted = data;
          $scope.slideObj.stage = 'results';
          AudioManager.play('glitch');
        }));
        $scope.formatTime = (function(t) {
          var s = (t % 60) + '';
          var m = (t / 60 << 0) + '';
          return m + ':' + (s.length == 1 ? '0' : '') + s;
        });
        var tick = (function() {
          $scope.countdownRemaining--;
          $scope.countdownPercentage = ($scope.countdownRemaining / $scope.slide.timer * 100) + '%';
          if ($scope.isCounting && $scope.countdownRemaining > 0) {
            $timeout(tick, 1000);
          } else {
            $scope.stopNonInteractiveVote();
            if ($scope.slide.timer_popup) {
              $scope.slideObj.timerpopup = 'show';
            }
          }
        });
        $scope.toggleNonInteractiveTimer = (function(countdown) {
          if ($scope.isCounting) {
            $scope.stopNonInteractiveVote();
          } else {
            $scope.startNonInteractiveVote(countdown);
          }
        });
        $scope.startNonInteractiveVote = (function(countdown) {
          $scope.isCounting = true;
          $scope.countdownRemaining = countdown;
          $timeout(tick, 1000);
        });
        $scope.stopNonInteractiveVote = (function() {
          $scope.isCounting = false;
          $scope.countdownRemaining = 0;
        });
      })
    };
  });
  ;
  return {};
});

